<template>
  <div class="wrap-lg">
    <div class="boxs-top clearfix">
      <div class="top-title"><span>推荐服务机构</span></div>
      <div class="top-more">
        <a href="javascript:void(0)" @click="toPage" style="text-decoration: none">
          查看更多
          <i class="el-icon-arrow-right"></i>
        </a>
      </div>
      <div class="switch-resource">
        <div v-for="(item) in commonUtils.getDictPara('recom_org_type')" :key="item.code"
             :class="(currIndex === item.code)? 'active-btn' : ''" @click="switchTab(item.code)"
              >{{item.name}}</div>
      </div>
    </div>
    <div class="top-divider"></div>
      <div class="org-list">
        <my-link :href="coorCompany.targetUrl? coorCompany.targetUrl : '/reorgs/detail?sid='+coorCompany.id" target="_blank" notRouter v-for="coorCompany in coorCompanys" :key="coorCompany.id">
          <div class="org-item">
              <img :src="coorCompany.logo"/>
              <span>{{coorCompany.name}}</span>
              <div class="org-desc">{{coorCompany.description}}</div>
          </div>
        </my-link>
      </div>
      <div style="height: 20px;display: block"></div>
  </div>
</template>

<script>
import { getLists } from '@/api/recommend/coorCompany'
export default {
  name: 'recommendOrg',
  data () {
    return {
      resourceType: '检测',
      loading: false,
      currIndex: 1,
      coorCompanys: []
    }
  },
  mounted () {
    this.initData()
    this.currIndex = this.commonUtils.getDictPara('recom_org_type')[0].code
  },
  methods: {
    initData: function () {
      // 初始化数据
      let params = {}
      params.categoryCode = this.currIndex
      getLists(params).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.coorCompanys = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    toPage () {
      this.$router.push({
        path: '/reorgs',
        query: {
          st: this.currIndex
        }
      })
    },
    switchTab (index) {
      this.currIndex = index
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .org-list {
    width: 100%;
    margin-bottom: 20px;
    overflow:auto;
    margin-top: 20px;
    .org-item {
      float: left;
      width: 262px;
      height: 110px;
      vertical-align: middle;
      margin: 2px;
      padding-top: 15px;
      &:hover {
        box-shadow: 0px 0px 15px 0px rgba(2, 91, 75, 0.2);
      }
      padding-left: 40px;
      background-color: #ffffff;
      img {
        height: 70px;
        max-width: 120px;
        vertical-align: middle;
      }
      span {
        margin-left: 10px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .org-desc{
        font-size: 14px;
        line-height: 22px;
        color: rgba(0,0,0,.45);
        margin: 10px 0 6px;
        width: 234px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
